import { render, staticRenderFns } from "./PatternC.vue?vue&type=template&id=0071b62c&scoped=true&"
import script from "./PatternC.vue?vue&type=script&lang=js&"
export * from "./PatternC.vue?vue&type=script&lang=js&"
import style0 from "./PatternC.vue?vue&type=style&index=0&id=0071b62c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0071b62c",
  null
  
)

export default component.exports